import "./index.css";
import Cookies from "js-cookie";
import Linkify from "react-linkify";
import ReplyInput from "../ReplyInput";
import { FaMicrophone, FaVideo } from "react-icons/fa6";
import Zoom from "react-medium-image-zoom";
import { CiVideoOn } from "react-icons/ci";
import VoiceMessage from "../VoiceMessage";
import { Box, Modal } from "@mui/material";
import { FaRegSmile } from "react-icons/fa";
import { useContext, useEffect, useState } from "react";
import { FaRegFilePdf } from "react-icons/fa";
import { FaPlayCircle } from "react-icons/fa";
import { LuCheckCheck } from "react-icons/lu";
import { Bounce, toast } from "react-toastify";
import { IoIosArrowDown } from "react-icons/io";
import { RxCrossCircled } from "react-icons/rx";
import { IoDocumentText } from "react-icons/io5";
import "react-medium-image-zoom/dist/styles.css";
import { HiOutlinePhotograph } from "react-icons/hi";
import { IoDocumentTextOutline } from "react-icons/io5";
import LinkPreviewSkeleton from "../LinkPreviewSkeleton";
import { MdOutlineDownloadForOffline } from "react-icons/md";
import { LinkPreview } from "@dhaiwat10/react-link-preview";
import CONSTANTS from "src/components/services/api";
import { MyContext } from "src/components/Context/MyContext";

const SendMessageTemplate = ({
  msgCss,
  openReply,
  data,
  isModalOpen,
  handleOpen,
  handleOpenModal,
  isHovered,
  onMouseEnter,
  onMouseLeave,
  handleMessageReply,
  setActiveAudio,
  activeAudio,
  handleCopy,
  scrollToMessage,
}) => {
  const replyData = data?.replyMessage?.length ? data.replyMessage[0] : null;
  const [videoModal, setVideoModal] = useState(false);
  const [imageModal, setImageModal] = useState(false);
  const [isZoomed, setIsZoomed] = useState(false);
  const [previewLoader, setPreviewLoader] = useState(false);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    border: "1px solid #F0F0F0",
    borderRadius: "8px",
    outline: "none",
    maxWidth: "100vw",
    maxHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    width: "100vw",
  };
  const [preview, setPreview] = useState({});
  const { userId } = useContext(MyContext);

  useEffect(() => {
    const fetchPreview = async () => {
      setPreviewLoader(true);

      try {
        if (data.content?.indexOf("http") === 0) {
          const res = await fetch(
            `${CONSTANTS.CHAT_BASE}/api/generateLinkPreview`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                url: data.content,
              }),
            }
          );

          if (!res.ok) {
            // This throws an error that will be caught in the catch block
            throw new Error(`Server error: ${res.status} ${res.statusText}`);
          }

          const result = await res.json();
          setPreview((prev) => ({
            ...prev,
            [`key_${data._id}`]: data?._id,
            title: result.data?.title,
            description: result.data?.description,
            image: result.data?.image?.url,
            url: result?.data?.url,
          }));
        }
      } catch (error) {
        console.error("Error fetching link preview:", error);
        // toast.error(error?.message || "An error occurred while fetching the link preview.", {
        //   position: "top-center",
        //   autoClose: 1000,
        //   transition: Bounce,
        // });
      } finally {
        setPreviewLoader(false);
      }
    };
    data.type === "text" &&
      data.content?.indexOf("http") === 0 &&
      fetchPreview();
  }, []);

  //get the type of document file
  function getFileTypeFromURL(url) {
    const urlParts = url.split("/");
    const fileName = urlParts[urlParts.length - 1];
    const fileExtension = fileName.split(".").pop().toLowerCase();

    switch (fileExtension) {
      case "pdf":
        return "pdf";
      case "doc":
      case "docx":
        return "Word Document";
      default:
        return "Unknown File Type";
    }
  }

  const downloadFile = async (dataFile) => {
    const url = dataFile;
    window.open(url, "_blank");
    // below is download document code
    // try {
    //   const response = await fetch(url);
    //   const blob = await response.blob();
    //   const blobUrl = window.URL.createObjectURL(blob);

    //   const link = document.createElement("a");
    //   link.href = blobUrl;
    //   link.setAttribute("download", "sample.pdf");
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);

    //   // Clean up blob URL
    //   window.URL.revokeObjectURL(blobUrl);
    // } catch (error) {
    //   console.error("Error downloading the file:", error);
    // }
  };

  return (
    <>
      <div
        onMouseLeave={onMouseLeave}
        onMouseEnter={() => onMouseEnter(data._id)}
      >
        {data?.isDeleted === true ? (
          <div
            className={`relative w-[272px] mt-3 bg-[#D9FFCC] text-sm font-normal flex flex-col justify-center rounded-[10px]  shadow-md shadow-[#7314ED1A] ${msgCss}`}
          >
            <div
              className={`relative w-full bg-[#CFC7C7] text-sm font-normal flex flex-col justify-center items-center px-4 py-2 rounded-[10px] rounded-tr-none shadow-md shadow-[#ED62141A] `}
            >
              <p className="text-sm font-normal">This message is deleted.</p>
            </div>
          </div>
        ) : (
          <div
            className={`relative w-full max-w-[40vw]  bg-[#D9FFCC] text-sm font-normal flex flex-col justify-center rounded-[10px] rounded-tr-none shadow-md shadow-[#7314ED1A] ${msgCss}`}
          >
            {/* show for the reply data  */}
            {data.replyMessage.length > 0 ? (
              <div
                onClick={() => scrollToMessage(data.replyMessage[0]._id)}
                className="cursor-pointer"
              >
                {data.replyMessage[0].type == "text" ? (
                  <Linkify
                    componentDecorator={(decoratedHref, decoratedText, key) => (
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={decoratedHref}
                        key={key}
                        className="link"
                      >
                        {decoratedText}
                      </a>
                    )}
                  >
                    <div className="rounded-[10px] flex w-[315px] bg-[#EAFCE7] h-[58px] overflow-hidden my-4 border-opacity-25  mt-3 mb-3">
                      <div className="bg-[#06CF9C] w-[5px] pl-1"></div>
                      <div className="ml-2 flex flex-col justify-center">
                        <h1 className="text-sm font-medium text-[#06CF9C]">
                          {String(data.replyMessage[0].author) == userId
                            ? "You"
                            : data.replyMessage[0].authorName}
                        </h1>
                        <p className="text-sm font-normal text-[#92929D] mt-2 text-nowrap text-ellipsis">
                          {data.replyMessage[0].content.length > 80
                            ? data.replyMessage[0].content.slice(0, 80)
                            : data.replyMessage[0].content}
                        </p>
                      </div>
                    </div>
                  </Linkify>
                ) : data.replyMessage[0].type == "image" ? (
                  <div className="rounded-[10px] flex w-full bg-[#EAFCE7] h-[58px] overflow-hidden my-4 border-opacity-25  mt-3 mb-3">
                    <div className="bg-[#06CF9C] w-[5px]"></div>
                    <div className="ml-2 flex flex-col justify-center w-full">
                      <h1 className="text-sm font-medium text-[#06CF9C]">
                        {String(data.replyMessage[0].author) == userId
                          ? "You"
                          : data.replyMessage[0].authorName}
                      </h1>
                      <div className="flex justify-between w-full items-center">
                        <div className="flex items-center gap-x-1">
                          <HiOutlinePhotograph />
                          <p>Photo</p>
                        </div>
                        <img
                          src={data.replyMessage[0].content}
                          className="w-[40px] h-[40px] rounded-[10px] mr-2"
                        />
                      </div>
                    </div>
                  </div>
                ) : data.replyMessage[0].type == "video" ? (
                  <div className="rounded-[10px] flex w-full bg-[#EAFCE7] h-[58px] overflow-hidden my-4 border-opacity-25  mt-3 mb-3">
                    <div className="bg-[#06CF9C] w-[5px]"></div>
                    <div className="ml-2 flex flex-col justify-center w-full">
                      <h1 className="text-sm font-medium text-[#06CF9C]">
                        {String(data.replyMessage[0].author) == userId
                          ? "You"
                          : data.replyMessage[0].authorName}
                      </h1>
                      <div className="flex justify-between w-full items-center">
                        <div className="flex items-center gap-x-1">
                          <CiVideoOn />
                          <p>Video</p>
                        </div>
                        <img
                          src={data.replyMessage[0].thumbnail}
                          className="w-[40px] h-[40px] rounded-[10px] mr-2"
                        />
                      </div>
                    </div>
                  </div>
                ) : data.replyMessage[0].type == "file" ? (
                  <div className="rounded-[10px] flex w-full bg-[#EAFCE7] h-[58px] overflow-hidden my-4 border-opacity-25  mt-3 mb-3">
                    <div className="bg-[#06CF9C] w-[5px]"></div>
                    <div className="ml-2 flex flex-col justify-center w-full">
                      <h1 className="text-sm font-medium text-[#06CF9C]">
                        {String(data.replyMessage[0].author) == userId
                          ? "You"
                          : data.replyMessage[0].authorName}
                      </h1>
                      <div className="flex justify-between w-full items-center">
                        <div className="flex items-center gap-x-1">
                          <IoDocumentTextOutline />
                          <p>
                            {
                              data.replyMessage[0].content.split("/")[
                                data.replyMessage[0].content.split("/").length -
                                  1
                              ]
                            }
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : data.replyMessage[0].type == "audio" ? (
                  <div className="rounded-[10px] flex w-[315px] bg-[#EAFCE7] h-[58px] overflow-hidden my-4 border-opacity-25  mt-3 mb-3">
                    <div className="flex ml-2 flex-row  w-full">
                      <div className="flex flex-col w-full">
                        <h1 className="text-sm font-medium text-[#06CF9C]">
                          {String(data.replyMessage[0].author) == userId
                            ? "You"
                            : data.replyMessage[0].authorName}
                        </h1>
                        <div className="flex items-center gap-x-1">
                          <FaMicrophone />
                          <p>
                            {" "}
                            Voice Message {data.replyMessage[0].audioDuration}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            ) : null}

            {/* if the type is image  */}
            {data?.type === "image" ? (
              <div className="w-[180px] h-[180px]  bg-[#D9FFCC]  flex  float-end justify-center items-center  rounded-[20px] shadow-sm shadow-[#7314ED1A] relative">
                <img
                  src={data?.content}
                  className="w-full h-full object-cover  rounded-[12px] cursor-pointer "
                  onClick={() => {
                    setImageModal(true);
                  }}
                />
                <p className="font-extralight text-[11px] text-white -mt-1.5 flex justify-end items-center gap-x-1 absolute bottom-0 right-2">
                  {data?.timeFormated}
                  <span>
                    {data?.isRead === false ? (
                      <LuCheckCheck size={16} />
                    ) : (
                      <LuCheckCheck size={16} color="blue" />
                    )}
                  </span>
                </p>
              </div>
            ) : null}
            {/* if the type is video  */}
            {data?.type === "video" ? (
              <div className="w-[180px] h-[180px] opacity-60 z-0  bg-white  flex  float-start justify-center items-center  rounded-[12px] shadow-sm shadow-[#ED62141A] relative">
                <img
                  src={data?.thumbnail}
                  className="w-full h-full object-cover  rounded-[12px]"
                />
                <p className="font-extralight text-[11px] text-white -mt-1.5 flex justify-end items-center gap-x-1 absolute bottom-0 right-2">
                  {data?.timeFormated}
                  <span>
                    {data?.isRead === false ? (
                      <LuCheckCheck size={16} />
                    ) : (
                      <LuCheckCheck size={16} color="blue" />
                    )}
                  </span>
                </p>
                <FaPlayCircle
                  size={35}
                  className="absolute opacity-100 z-50 cursor-pointer"
                  color="white"
                  onClick={() => setVideoModal(true)}
                />
                <FaVideo className="absolute bottom-0 left-1" color="white" />
              </div>
            ) : null}

            {/* if the type is audio type */}
            {data?.type === "audio" ? ( 
              <div className="px-2 pt-2 pb-1">
                <VoiceMessage
                  audioSrc={data?.content}
                  duration={data?.audioDuration}
                  setActiveAudio={setActiveAudio}
                  activeAudio={activeAudio}
                />
                <p className="font-extralight text-[11px] text-[#76767CCC] -mt-1.5 flex justify-end items-center gap-x-1">
                  {data?.timeFormated}
                  <span>
                    {data?.isRead === false ? (
                      <LuCheckCheck size={16} />
                    ) : (
                      <LuCheckCheck size={16} color="blue" />
                    )}
                  </span>
                </p>
              </div>
            ) : null}

            {/* if the type is text type */}
            {data?.type === "text" ? (
              <div className="pl-3 pt-2 pb-1 pr-2">
                {!previewLoader ? (
                  data.content?.indexOf("http") === 0 &&
                  Object.values(preview).length > 0 &&
                  preview[`key_${data._id}`] === String(data._id) ? (
                    <div className="w-[300px]">
                      <a
                        href={preview.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {preview.image && (
                          <img
                            src={preview.image}
                            alt="preview"
                            className="w-full h-48 object-cover mb-2 rounded-t-2xl"
                          />
                        )}
                        <div className="font-bold max-h-14 overflow-hidden">
                          {preview.title}
                        </div>
                        <div className="text-sm text-gray-600 max-h-24 overflow-hidden">
                          {preview.description}
                        </div>
                        <Linkify
                          componentDecorator={(
                            decoratedHref,
                            decoratedText,
                            key
                          ) => (
                            <a
                              target="_blank"
                              rel="noopener noreferrer"
                              href={decoratedHref}
                              key={key}
                              className="link"
                            >
                              {preview?.url}
                            </a>
                          )}
                        >
                          <p className="leading-relaxed break-words whitespace-pre-wrap  ">
                            {data?.content}
                          </p>
                        </Linkify>
                      </a>
                    </div>
                  ) : (
                    <Linkify
                      componentDecorator={(
                        decoratedHref,
                        decoratedText,
                        key
                      ) => (
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={decoratedHref}
                          key={key}
                          className="link"
                        >
                          {decoratedText}
                        </a>
                      )}
                    >
                      <p className="leading-relaxed break-words whitespace-pre-wrap  ">
                        {data?.content}
                      </p>
                    </Linkify>
                  )
                ) : (
                  <LinkPreviewSkeleton />
                )}
                <p className="font-extralight text-[11px] text-[#76767CCC] -mt-1.5 flex justify-end items-center gap-x-1">
                  {data?.timeFormated}
                  <span>
                    {data?.isRead === false ? (
                      <LuCheckCheck size={16} />
                    ) : (
                      <LuCheckCheck size={16} color="blue" />
                    )}
                  </span>
                </p>
              </div>
            ) : null}

            {/* if the type is file type */}
            {data?.type === "file" ? (
              <div
                className="w-[270px] h-[180px]  bg-white  flex  float-start justify-center items-center  rounded-[12px] shadow-sm shadow-[#ED62141A] relative"
                onClick={() => downloadFile(data.content)}
              >
                <img
                  src={data?.thumbnail}
                  className="w-full h-full object-cover  rounded-[12px]"
                />
                <div className="bg-green-200 h-[75px] absolute bottom-0 w-full">
                  <div className="flex py-3 bg-green-100 m-1 border-r-2 justify-between">
                    <div className="flex">
                      {getFileTypeFromURL(data.content) == "pdf" ? (
                        <FaRegFilePdf size={20} />
                      ) : getFileTypeFromURL(data.content) ==
                        "Word Document" ? (
                        <IoDocumentText size={20} />
                      ) : null}
                      <p className="text-sm pl-2 w-[195px] overflow-hidden">
                        {
                          data.content.split("/")[
                            data.content.split("/").length - 1
                          ]
                        }
                      </p>
                    </div>
                    <MdOutlineDownloadForOffline color="#495057" size={25} />
                  </div>
                  <p className="font-extralight text-[11px] text-white -mt-1.5 flex justify-end items-center gap-x-1 absolute bottom-0 right-2">
                    {data?.timeFormated}
                    <span>
                      {data?.isRead === false ? (
                        <LuCheckCheck size={16} />
                      ) : (
                        <LuCheckCheck size={16} color="blue" />
                      )}
                    </span>
                  </p>
                </div>
              </div>
            ) : null}

            {(isHovered || isModalOpen) && (
              <div className="absolute top-0 right-0 z-50">
                <div className="flex justify-between justify-self-end bg-white shadow-[#ED62141A] shadow-md rounded-[35px] py-2 px-3 w-[70px] !float-right">
                  <IoIosArrowDown
                    size={20}
                    color="#92929D"
                    onClick={handleOpen}
                    className="cursor-pointer"
                  />
                  <FaRegSmile size={20} color="#92929D" />
                </div>
                {openReply && (
                  <ReplyInput
                    deleteHandler={handleOpenModal}
                    replyHandler={handleMessageReply}
                    copyHandler={handleCopy}
                    type="sender"
                    Css="!left-0 !mt-12 "
                  />
                )}
              </div>
            )}
          </div>
        )}
      </div>
      {videoModal || imageModal ? (
        <Modal
          open={videoModal || imageModal}
          // onClose={() => console.log("on-close >>>")}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          BackdropProps={{
            style: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          }}
        >
          <Box sx={style}>
            <div className="flex items-center justify-center relative h-full w-full p-1">
              <RxCrossCircled
                size={35}
                className="absolute right-4 top-4 cursor-pointer"
                onClick={() => {
                  setVideoModal(false);
                  setImageModal(false);
                }}
              />

              {!imageModal ? (
                <video
                  src={data?.content}
                  controls
                  autoPlay={true}
                  muted={false}
                  className="max-w-full max-h-full rounded-[12px]"
                />
              ) : (
                <div className=" w-full flex justify-center items-center">
                  {isZoomed ? (
                    <Zoom>
                      <img
                        src={data?.content}
                        className="max-w-full max-h-full h-[120vh] object-cover rounded-[12px]"
                      />
                    </Zoom>
                  ) : (
                    <img
                      src={data?.content}
                      className="w-auto h-[90vh] object-contain rounded-[12px]"
                      onClick={() => setIsZoomed(true)}
                    />
                  )}
                </div>
              )}
            </div>
          </Box>
        </Modal>
      ) : null}
    </>
  );
};

export default SendMessageTemplate;
